module.exports = __webpack_public_path__ + "img/slider2.4ee8bb71.jpg";